<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb breadcrumb-no-gutter">
            <li class="breadcrumb-item">
                <router-link :to="{name:'Dashboard'}" class="breadcrumb-link">Tableau de bord</router-link>
            </li>


            <li :class="breads.length == i+1 ? 'breadcrumb-item active' :'breadcrumb-item '" v-for="(bread, i) in breads" :key="i" aria-current="page">
                <span class="breadcrumb-link" v-if="!bread.to">{{ bread.name }}</span>
                <router-link :to="{ name: bread.to }" class="breadcrumb-link" v-else>{{ bread.name }}</router-link>
            </li>
        </ol>
    </nav>
</template>
<script>
export default {
    name: "BreadCrumb",
    props: {
        breads: {
            type: Array,
            required: true
        },

    }
}
</script>